<script>
	//	items: [{ key, name, color, kind: 'line'|'rect', hidden }]
	export let items = [];
	export let onToggle = null;
	export let interactive = false;
</script>

<ul class="legend" aria-label="Legendă">
	{#each items as it (it.key)}
		<li>
			<button
				type="button"
				aria-pressed={!it.hidden}
				class:off={it.hidden}
				class:static={!interactive}
				disabled={!interactive}
				on:click={() => interactive && onToggle && onToggle(it.key)}
			>
				{#if it.kind === "line"}
					<svg class="line-swatch" width="24" height="12" viewBox="0 0 24 12" aria-hidden="true"><path d="M1 6H23" stroke={it.color} stroke-width="2.5" stroke-linecap="round" stroke-dasharray={it.dash} /></svg>
				{:else}
					<span class="swatch" style="--c:{it.color}" aria-hidden="true"></span>
				{/if}
				<span class="name">{it.name}</span>
			</button>
		</li>
	{/each}
</ul>

<style>
	.legend {
		list-style: none;
		margin: 0 0 12px;
		padding: 0;
		display: flex;
		flex-wrap: wrap;
		gap: 0 16px;
		font-size: 14px;
		line-height: 1.4;
	}

	li {
		min-width: 0;
		max-width: 100%;
		margin: 0;
		padding: 0;
	}

	button {
		appearance: none;
		background: none;
		border: 0;
		padding: 8px 4px;
		min-height: 44px;
		box-sizing: border-box;
		max-width: 100%;
		text-align: left;
		margin: 0;
		font: inherit;
		color: var(--_ink);
		display: inline-flex;
		align-items: center;
		gap: 7px;
		cursor: pointer;
		border-radius: 3px;
	}

	button.static {
		cursor: default;
	}

	button:focus-visible {
		outline: 2px solid var(--_accent);
		outline-offset: 1px;
	}

	button.off .name {
		color: var(--_ink-muted);
		text-decoration: line-through;
	}

	button.off .swatch {
		opacity: 0.35;
	}
	button.off .line-swatch { opacity: 0.35; }
	button:hover:not(:disabled) { background: var(--_wash); }
	.name { min-width: 0; overflow-wrap: anywhere; }
	.line-swatch, .swatch { flex: 0 0 auto; }

	.swatch {
		display: inline-block;
		width: 14px;
		height: 10px;
		background: var(--c);
		border-radius: 2px;
	}

</style>
